import styled from 'styled-components';

export const StyledModalWrapper = styled.div`  
  .container {
    width: auto !important;
  }
`;